import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Routes } from '../../enums';
import styles from './header.module.css';
import { ReactComponent as Logo } from '../../resources/ActiveReports.NET.svg';
import { ReactComponent as LogoBrandSmall } from '../../resources/mescius-logomark-w.svg';
import { ReactComponent as LogoBrand } from '../../resources/mescius-logo-w.svg';

export default function Header() {
  const [shownMobileMenu, toggleMenu] = useState<boolean>(false);

  const menuItems = [{ to: Routes.Reports, name: 'Demo' }];

  return (
    <div className={styles.root}>
      <div className={styles.branding}>
        <a href={Routes.GrapeCityHomePage} >
          <LogoBrandSmall className={styles.logoBrandSmall}/>
        </a>
        <a href={Routes.GrapeCityHomePage}>
          <LogoBrand className={styles.logoBrand}/>
        </a>
        <div className={styles.logoSplitter}></div>
        <a href={Routes.ActiveReportsHomePage} title="ActiveReports">
          <Logo className={styles.logoProduct}/>
        </a>
      </div>
      <div className={styles.toggle} data-mobile onClick={() => toggleMenu(!shownMobileMenu)}>
        {!shownMobileMenu && (
          <svg focusable="false" width="24" height="24" viewBox="0 0 24 24">
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
          </svg>
        )}
        {shownMobileMenu && (
          <svg width="14px" height="14px" viewBox="0 0 10 10" focusable="false">
            <polygon points="10,1.01 8.99,0 5,3.99 1.01,0 0,1.01 3.99,5 0,8.99 1.01,10 5,6.01 8.99,10 10,8.99 6.01,5 " />
          </svg>
        )}
      </div>
      <div className={`${styles.menu} ${shownMobileMenu ? styles.menu_showMobile : ''}`}>
        <div className={styles.menuGroup}>
          {menuItems.map((item) => (
            <NavLink
              key={`MenuItem_${item.name}`}
              className={styles.menuItem}
              activeClassName={styles.menuItem_active}
              to={item.to}
            >
              {item.name}
            </NavLink>
          ))}
          <a href={Routes.Docs} className={styles.menuItem}>
            Doc
          </a>
        </div>
        <div className={styles.menuGroup}>
          <a className={styles.menuButton} href={Routes.ActiveReportsDownload} data-desktop>
            Download
          </a>
        </div>
      </div>
    </div>
  );
}
